import { render, staticRenderFns } from "./SurgeryPatientHistoryAccounting.vue?vue&type=template&id=71d1e80e&scoped=true"
import script from "./SurgeryPatientHistoryAccounting.vue?vue&type=script&lang=js"
export * from "./SurgeryPatientHistoryAccounting.vue?vue&type=script&lang=js"
import style0 from "./SurgeryPatientHistoryAccounting.vue?vue&type=style&index=0&id=71d1e80e&prod&scoped=true&lang=css"
import style1 from "./SurgeryPatientHistoryAccounting.vue?vue&type=style&index=1&id=71d1e80e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d1e80e",
  null
  
)

export default component.exports